import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    placement: String,
    boundary: String,
    selector: String,
  };

  connect() {
    this.enableTooltips();
  }

  enableTooltips() {
    const options = {
      placement: this.placementValue,
      boundary: this.boundaryValue,
    };
    $(this.selectorValue).tooltip(options);
  }
}
